import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { Container, Info } from './styles'
import RedesSociais from '../RedesSociais'
import AgendarVisita from '../AgendarVisita'
import useFaleConoscoMetadata from '../../hooks/QueryMenuFaleConosco'
import certificacao from '../../icons/certificacao.svg'

export default function Footer() {
  const menuFaleConosco = useFaleConoscoMetadata()
  const data = useStaticQuery(graphql`
    query footerQuery {
      melhorMaternidade: file(relativePath: { eq: "img/datafolha.png" }) {
        childImageSharp {
          fixed(width: 210, height: 118) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      bg: file(relativePath: { eq: "img/footer-bg.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            srcWebp
          }
        }
      }
    }
  `)
  return (
    <>
      <Container
        style={{
          backgroundImage: `url(${data.bg.childImageSharp.fluid.srcWebp})`,
        }}
      >
        <div className="inner">
          <h4>Nossas certificações</h4>
          <div className="certificacoes">
            <p>
              Eleita pelo sexto ano consecutivo a melhor maternidade de São
              Paulo
            </p>
            <Img
              alt="Prêmios Datafolha: 6 anos Melhor maternidade de São Paulo"
              fixed={data.melhorMaternidade.childImageSharp.fixed}
            />
            <p>
              Certificada com nível máximo de segurança e assistência à saúde
            </p>
            <img src={certificacao} alt="Certificação" height="94" width="94" />
          </div>
          <div className="footerNav">
            <div>
              <h4>Fale conosco</h4>
              <ul>
                {menuFaleConosco.nodes[3].childItems.nodes.map(item => (
                  <li key={item.id}>
                    <Link to={item.url}>{item.label}</Link>
                  </li>
                ))}
                <li>
                  <Link to="/politica-de-privacidade">
                    Política de privacidade
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4>Imprensa</h4>
              <ul>
                <li>
                  <Link to="/sala-de-imprensa">Matérias</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4>Grupo Santa Joana</h4>
              <ul>
                <li>
                  <a
                    href="http://maternidadesantamaria.com.br/"
                    title="Maternidade Santa Maria"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Hospital e Maternidade Santa Maria
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.promatresp.com.br/"
                    title="Maternidade Pro Matre Paulista"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Hospital e Maternidade Pro Matre Paulista
                  </a>
                </li>
                <li>
                  <a
                    href="https://gruposantajoana.com.br/ensinoepesquisa/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Conheça o Grupo Santa Joana
                  </a>
                </li>
              </ul>
            </div>
            <div className="social">
              <h4>Social</h4>
              <RedesSociais />
            </div>
          </div>
        </div>
      </Container>
      <Info>
        <p>
          <strong>© 2020 Santa Joana. Todos os direitos reservados.</strong>
        </p>
        <p>
          Rua do Paraíso, 432 | CEP 04103-000 | Paraíso | São Paulo | SP | 11
          5080 6000
        </p>
        <p>Responsável Técnico: Dr. Eduardo Rahme Amaro | CRM 31624</p>
      </Info>
      <AgendarVisita />
    </>
  )
}
